import { IAstNode, IAtomAstNode, IPathWithDirectionAstNode, IComposeFunc } from '../../typings/ast-node';
import { TokenComposeError } from '../../errors';



export function composePathDirection(astNodes: IAstNode[], compose: IComposeFunc) {
  const i = astNodes.findIndex((currentNode, index) => {
    const nextNode = astNodes[index + 1];
    if (currentNode.type === 'Temporary' && ['ModelProperty', 'FqnProperty'].includes(currentNode.token.type) &&
      nextNode && nextNode.type === 'Temporary' && nextNode.token.type === 'Direction') {
      return true;
    }
    return false;
  });

  if (i === -1) return;

  const directionNode = astNodes[i + 1] as IAtomAstNode;
  const token = astNodes[i].token!;

  if (!directionNode) {
    throw new TokenComposeError('incomplete-expression', '表达式不完整', token.position);
  }


  const node: IPathWithDirectionAstNode = {
    type: 'Atom',
    token,
    pathNode: astNodes[i],
    directionNode,
    withDirection: true
  };

  astNodes.splice(i, 2, node);

  composePathDirection(astNodes, compose);
}
